// prepr auth config
export const PREPR_AUTH_USER_COOKIE_NAME = "auth_user";
export const PREPR_AUTH_ACCESS_TOKEN_COOKIE_NAME = "auth_access_token";
export const PREPR_AUTH_EXPIRES_IN = 60 * 60 * 24 * 30; // 30 days
